module.exports = {"top3":["Employer-sponsored insurance spending per enrollee","Home health patients without improved mobility","Alcohol deaths"],"bottom3":["Breast cancer deaths","Nursing home residents with a hospital admission","Mortality amenable to health care"],"most_improved":["Home health patients without improved mobility","Adults with any mental illness who did not receive treatment","High out-of-pocket medical spending"],"most_declined":["Preventable hospitalizations ages 18-64","Children without all recommended vaccines","Hospital 30-day mortality"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/MS.json
// module id = 265
// module chunks = 143196823979170 184088790168614